import { render, staticRenderFns } from "./CmgRewardsPointsHistory.vue?vue&type=template&id=3d9f8706&scoped=true&lang=pug&"
import script from "./cmg-rewards-points-history.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-points-history.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f8706",
  null
  
)

export default component.exports